/*
Mixin for record live search. Available classes: Needy, Foundation, Contractor, Cause, User
*/

export const SearchesMixin = (controller, klass = 'Needy') => {
  const NEEDIES_SEARCH_PATH = '/panel/needies/searches?q={query}&';
  const ORGANIZATIONS_SEARCH_PATH = '/panel/organizations/searches?q={query}&';
  const CAUSES_SEARCH_PATH = '/panel/causes/searches?q={query}&';
  const CONTRACTORS_SEARCH_PATH = '/panel/contractors/searches?q={query}&';
  const INVOICES_CONTRACTORS_SEARCH_PATH =
    '/panel/invoices/contractors/searches?q={query}&';
  const USERS_SEARCH_PATH = '/panel/users/searches?q={query}&';

  Object.assign(controller, {
    initializeSearch(params, callbacks, customTemplates = {}) {
      $(params.selector).search({
        apiSettings: { url: this.buildQueryUrl(params.query) },
        searchDelay: 500,
        maxResults: 5,
        error: { noResults: params.noResultsMessage },
        templates: {
          message: (msg, type) => {
            return $.fn.search.settings.templates
              .message(msg, type)
              .replaceAll('No Results', 'Brak');
          },
          ...customTemplates,
        },
        ...callbacks,
      });
    },

    buildQueryUrl(queryParams) {
      const params = Object.entries(queryParams)
        .map(([param, value], i) => `${param}=${value}`)
        .join('&');

      if (!klass) {
        klass = 'Needy';
      }

      switch (klass) {
        case 'Needy':
          return NEEDIES_SEARCH_PATH + params;
        case 'Organization':
          return ORGANIZATIONS_SEARCH_PATH + params;
        case 'Cause':
          return CAUSES_SEARCH_PATH + params;
        case 'Contractor':
          return CONTRACTORS_SEARCH_PATH + params;
        case 'Invoices::Contractor':
          return INVOICES_CONTRACTORS_SEARCH_PATH + params;
        case 'User':
          return USERS_SEARCH_PATH + params;
      }
    },

    customResultsTemplate() {
      return {
        standard: (response) => this.renderResults(response),
        message: (message, type) =>
          `<div class="result">${$.fn.search.settings.templates.message(message, type).replaceAll('No Results', 'Brak')}</div>`,
      };
    },

    renderResults(response) {
      return response.results
        .map(
          (object) => `
        <div class="result">
          ${this.renderConditionally(object, 'title', 'title')}
          ${this.renderConditionally(object, 'description', 'description')}
        </div>
      `,
        )
        .join('');
    },

    renderConditionally(object, field, className = '') {
      if (object[field]) {
        const div = document.createElement('div');
        div.className = className;
        div.textContent = object[field];
        return div.outerHTML;
      }
      return '';
    },
  });
};
